import {
    Box,
    Button,
    Link,
    Typography
} from "@mui/material";
import {
    CONTACT_EMAIL,
    CONTACT_PHONE_NUMBER,
    CONTACT_WEBSITE
} from "../../lib/dashboard/constants/Contact";

import InternetIcon from "../icons/InternetIcon";
import MailIcon from "../icons/MailIcon";
import PhoneIcon from "../icons/PhoneIcon";

export const ContactUs = () => {
    return (
        <Box display="flex" flexDirection="column">
            <Typography color="primary.main">
                Need Help?
            </Typography>
            <Button
                component={Link}
                href={CONTACT_PHONE_NUMBER.getURI()}
                color="inherit"
                startIcon={<PhoneIcon />}
                sx={{ justifyContent: "flex-start" }}
            >
                {CONTACT_PHONE_NUMBER.formatNational()}
            </Button>
            <Button
                component={Link}
                href={`mailto:${CONTACT_EMAIL}`}
                color="inherit"
                startIcon={<MailIcon />}
                sx={{ justifyContent: "flex-start", textTransform: "none" }}
            >
                {CONTACT_EMAIL}
            </Button>
            <Button
                onClick={() => {
                    window.open(`https://${CONTACT_WEBSITE}`, "_blank");
                }}
                color="inherit"
                startIcon={<InternetIcon />}
                sx={{ justifyContent: "flex-start", textTransform: "none" }}
            >
                {CONTACT_WEBSITE}
            </Button>
        </Box>
    );
};